import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  NavDropdown,
  Button,
  Dropdown,
  Modal,
  Row,
  Card,
  Badge,
  Col,
} from "react-bootstrap";
import { useNavigate, Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import "./NavbarMenu.css";
import Logo from "../../assets/images/logo.png";
import { authAPI } from "../../api/apiSystem";
import { languages } from "../../data/languages";
import ReactCountryFlag from "react-country-flag";
import { settingsAPI } from "../../api/apiSystem";
import NotificationBell from "../navbar/NotificationBell";

import paletteImg from '../../assets/images/transport_form_icon/palette.png';
import paketeImg from '../../assets/images/transport_form_icon/pakete.png';
import documentImg from '../../assets/images/transport_form_icon/document.png';
import furnitureImg from '../../assets/images/transport_form_icon/furniture.png';
import electricalImg from '../../assets/images/transport_form_icon/electrical.png';
import tiresImg from '../../assets/images/transport_form_icon/tires.png';
import refrigeratorImg from '../../assets/images/transport_form_icon/refrigerator.png';
import buildingMaterialsImg from '../../assets/images/transport_form_icon/building_materials.png';
import movingImg from '../../assets/images/transport_form_icon/moving.png';
import bicycleImg from '../../assets/images/transport_form_icon/bicycle.png';
import motorcycleImg from '../../assets/images/transport_form_icon/motorcycle.png';
import carImg from '../../assets/images/transport_form_icon/car.png';
import animalTransportImg from '../../assets/images/transport_form_icon/animal_transport.png';
import otherImg from '../../assets/images/transport_form_icon/other.png';

// Categorized transport options based on the design
const transportCategories = [
  {
    // category: "transportModal.categories.general",
    category: "",
    options: [
      { des: "", name: "palette", label: "palette", img: paletteImg, popular: true },
      { des: "", name: "pakete", label: "pakete", img: paketeImg, popular: true },
      { des: "", name: "document", label: "document", img: documentImg, popular: true },
      { des: "", name: "moving", label: "moving", img: movingImg },
      { des: "", name: "furniture", label: "furniture", img: furnitureImg },
      // { des: "", name: "other", label: "Sonstige", img: otherImg, isOther: true },
      { des: "", name: "electrical", label: "electrical", img: electricalImg },
    ]
  },
  {
    // category: "transportModal.categories.household",
    category: "",
    options: [
      { des: "", name: "building materials", label: "building materials", img: buildingMaterialsImg },
      { des: "", name: "tires", label: "tires", img: tiresImg },
      { des: "", name: "animal transport", label: "animal transport", img: animalTransportImg },
    ]
  },
  {
    // category: "transportModal.categories.vehicles",
    category: "",
    options: [
      { des: "", name: "motorcycle", label: "motorcycle", img: motorcycleImg },
      { des: "", name: "car", label: "car", img: carImg },
      { des: "", name: "bicycle", label: "bicycle", img: bicycleImg },
    ]
  },
 
];

// Flat list for backwards compatibility
const transportOptions = transportCategories.flatMap(cat => cat.options);

export default function UmzugNavbarMenu({
  selectedTransport,
  setSelectedTransport,
}) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tempSelection, setTempSelection] = useState(selectedTransport);
  const [showModal, setShowModal] = useState(false);

  const [userType, setUserType] = useState(
    typeof window !== "undefined" ? localStorage.getItem("userType") : null,
  );

  const handleSelect = (option) => {
    setTempSelection(option);
    
    setTimeout(() => {
      setShowModal(false);
      
      // Navigate to transport page with selected type
      const transportType = option.name;
      navigate(`/transport?type=${transportType}`);
      
      // Optional: save to localStorage as backup
      localStorage.setItem("selectedTransport", JSON.stringify(option));
    }, 150);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");

        const [settingsRes] = await Promise.all([settingsAPI.index()]);

        if (settingsRes?.success && settingsRes.data?.data?.length > 0) {
          setSettings(settingsRes.data.data[0]);
        }
      } catch (err) {
        console.error("Error fetching settings or socials:", err);
        setError("Failed to load settings or social links.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handler = () => {
      setUserType(localStorage.getItem("userType"));
    };

    window.addEventListener("userTypeChanged", handler);
    const storageHandler = (e) => {
      if (e.key === "userType") handler();
    };
    window.addEventListener("storage", storageHandler);

    return () => {
      window.removeEventListener("userTypeChanged", handler);
      window.removeEventListener("storage", storageHandler);
    };
  }, []);

  // Listen for mobile menu open events from MobileNavbar
  useEffect(() => {
    const openHandler = () => {
      try {
        const toggler = document.querySelector(".navbar-new .navbar-toggler");
        if (toggler) toggler.click();
      } catch (err) {
        console.error("Error toggling navbar from mobile menu event", err);
      }
    };

    window.addEventListener("openMobileMenu", openHandler);

    return () => {
      window.removeEventListener("openMobileMenu", openHandler);
    };
  }, []);

  // ✅ تغيير اللغة
  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem("language", languageCode);
  };

  // ✅ الحصول على اللغة الحالية
  const getCurrentLanguage = () => {
    return (
      languages.find((lang) => lang.code === i18n.language) || languages[1]
    );
  };

  // ✅ تسجيل خروج
  const handleLogout = async () => {
    try {
      const response = await authAPI.logout();

      if (response.success) {
        localStorage.removeItem("userType");
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        setUserType(null);
        window.dispatchEvent(new Event("userTypeChanged"));

        Swal.fire({
          icon: "success",
          title: t("logoutSuccess") || "You have successfully logged out",
          showConfirmButton: false,
          timer: 2000,
        });

        navigate("/");
      } else {
        Swal.fire({
          icon: "error",
          title: t("logoutError") || "Error in logout",
          text: response.message || "Failed to logout",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("logoutError") || "Error in logout",
        text: error.message || "Failed to logout",
      });
    }
  };

  return (
    <>
    <Navbar expand="xl" className="navbar-new">
      <div className="container-fluid px-3 px-md-5">
        {/* ✅ لوجو */}
        <Navbar.Brand
          as={Link}
          to={userType === "vehicle" ? "/vehicle/active-orders" : "/"}
          style={{
            display: "flex",
            alignItems: "center",
            width: "150px",
            height: "45px",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {settings?.logo && (
            <img
              src={settings.logo}
              height="50"
              alt="Transcirox"
              style={{ width: "100%" }}
            />
          )}
        </Navbar.Brand>

        {/* ── Hamburger + Bell together on mobile ── */}
        <div className="d-xl-none d-flex align-items-center gap-2">
          {userType && <NotificationBell />}
          <Navbar.Toggle aria-controls="navbar-nav" />
        </div>
        <Navbar.Collapse id="navbar-nav" className="justify-content-between">
          {/* Close button for mobile sidebar */}
          <button
            className="mobile-sidebar-close d-lg-none"
            onClick={() => {
              const toggler = document.querySelector(
                ".navbar-new .navbar-toggler",
              );
              if (toggler) toggler.click();
            }}
            aria-label="Close menu"
          >
            ✕
          </button>
          <Nav className="mx-auto gap-4">
            {!userType && (
              <>
                <Nav.Link as={NavLink} to="/transport">
                  {t("navbar.home")}
                </Nav.Link>

                <Nav.Link as={NavLink} to="/about" >
                  {t("navbar.about")}
                </Nav.Link>

                <Nav.Link 
                  // as={NavLink} 
                  to="#"
                  onClick={() => {
                    setTempSelection(selectedTransport);
                    setShowModal(true);
                  }}
                >
                  {t("navbar.services")}
                </Nav.Link>

                <Nav.Link 
                  onClick={() => navigate("/transport")}
                >
                  {t("courierTransport")}
                </Nav.Link>

                <Nav.Link as={NavLink} to="/faq-umzug" >
                  {t("FAQ")}
                </Nav.Link>

                {/* <NavDropdown
                  title={t("navbar.speditionsversand")}
                  id="speditionsversand-dropdown"
                >
                  <NavDropdown.Item
                    onClick={() => navigate("/register/client")}
                  >
                    {t("navbar.register")}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/Kurierfahrzeug")}>
                    {t("vehicleOverview")}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => navigate("/Speditionsversand")}
                  >
                    {t("speditionsversand")}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/faq-versand")}>
                    {t("shippingFAQ")}
                  </NavDropdown.Item>
                </NavDropdown> */}

                {/* <NavDropdown
                  title={t("courierTransport")}
                  id="kuriertransport-dropdown"
                >
                  <NavDropdown.Item as={NavLink} to="/register/driver">
                    {t("navbar.register")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/Kuriertransport">
                    {t("transportOrders")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/transportpartner-werden">
                    {t("becomePartner")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/faq-partner">
                    {t("partnerFAQ")}
                  </NavDropdown.Item>
                </NavDropdown> */}

                <Nav.Link as={NavLink} to="/contact">
                  {t("navbar.contactUs")}
                </Nav.Link>
              </>
            )}

            {/* ====================== عميل ====================== */}
            {["client", "guest"].includes(userType) && (
              <>
                <Nav.Link as={NavLink} to="/">
                  {t("navbar.home")}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/user/booking">
                  {t("ordersOverview")}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/rechnungen-client">
                  {t("invoice")}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/clientinfo">
                  {t("navbar.contact")}
                </Nav.Link>
              </>
            )}

            {/* ====================== سائق ====================== */}
            {userType === "driver" && (
              <>
                <Nav.Link as={NavLink} to="/driver/driver-offer">
                  {t("myOffers")}
                </Nav.Link>
                <NavDropdown
                  title={t("transportOrders")}
                  id="driver-orders-dropdown"
                >
                  <NavDropdown.Item as={NavLink} to="/driver/driver-details">
                    {t("orderMap")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/driver/map">
                    {t("Map")}
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item as={NavLink} to="/driver/driver-offer">
                    {t("myOffers")}
                  </NavDropdown.Item> */}
                  <NavDropdown.Item as={NavLink} to="/driver/driver-request">
                    {t("myOrders")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/driver/driver-completed">
                    {t("completedOrders")}
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link as={NavLink} to="/driver/vehicle-table">
                  {t("navbar.vehicles")}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/driver/rechnungen-driver">
                  {t("invoice")}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/driver/driver-info">
                  {t("navbar.contact")}
                </Nav.Link>
              </>
            )}

            {/* ====================== مركبة (سائق فرعي) ====================== */}
            {userType === "vehicle" && (
              <>
                <Nav.Link as={NavLink} to="/vehicle/active-orders">
                  {t("driverActive.title") || "Active Orders"}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/vehicle/completed-orders">
                  {t("driverCompleted.title") || "Completed Orders"}
                </Nav.Link>
              </>
            )}
          </Nav>

          <div className="nav-buttons d-flex gap-2 align-items-center">
            {/* ✅ زر الترجمة - الأعلام فقط */}
            <Dropdown className="me-2">
              <Dropdown.Toggle
                variant="outline-light"
                size="sm"
                className="language-toggle d-flex align-items-center justify-content-center gap-2"
              >
                <div className="selected-flag rounded-circle overflow-hidden">
                  <ReactCountryFlag
                    countryCode={getCurrentLanguage().countryCode}
                    svg
                    style={{
                      width: "1.5em",
                      height: "1.5em",
                      objectFit: "cover",
                    }}
                    title={t(getCurrentLanguage().country)}
                  />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="language-dropdown flags-only">
                <div className="flags-grid">
                  {languages.map((language) => (
                    <Dropdown.Item
                      key={language.code}
                      onClick={() => handleLanguageChange(language.code)}
                      className={`flag-item ${
                        i18n.language === language.code ? "selected" : ""
                      }`}
                      title={t(language.country)}
                    >
                      <div
                        className={`flag-wrapper ${
                          i18n.language === language.code
                            ? "selected-flag-border"
                            : ""
                        }`}
                      >
                        <ReactCountryFlag
                          countryCode={language.countryCode}
                          svg
                          style={{
                            width: "2em",
                            height: "2em",
                            objectFit: "cover",
                          }}
                          title={t(language.country)}
                        />
                      </div>
                      <span className="language-name">{language.name}</span>
                    </Dropdown.Item>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>

            {!userType && (
              <>
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={() => navigate("/login")}
                >
                  {t("navbar.login")}
                </Button>
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={() => navigate("/register")}
                >
                  {t("navbar.register")}
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  className="bg-orange-500 text-white"
                  onClick={() => navigate("/login-guest")}
                >
                  {t("navbar.loginAsGuest")}
                </Button>
              </>
            )}

            {userType == "guest" && (
              <Button
                variant="warning"
                size="sm"
                className="bg-orange-500 text-white"
                onClick={() => navigate("/set-password")}
              >
                {t("navbar.setPassword")}
              </Button>
            )}

            {/* Desktop only – hidden on mobile (shown outside collapse above) */}
            {userType && (
              <div className="d-none d-xl-flex">
                <NotificationBell />
              </div>
            )}

            {userType && (
              <Button variant="outline-light" size="sm" onClick={handleLogout}>
                {t("navbar.logout")}
              </Button>
            )}
          </div>
        </Navbar.Collapse>
      </div>
    </Navbar>


    {/* Transport types modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="transport-type-modal"
      >
        <Modal.Header closeButton className="transport-modal-header">
          <Modal.Title>{t("select_transport_type")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="transport-modal-body">
          {transportCategories.map((category, catIndex) => (
            <div key={catIndex} className="transport-category-section">
              <h6 className="transport-category-title">{t(category.category)}</h6>
              <Row className="g-3 mb-4">
                {category.options.map((option) => (
                  <Col xs={6} md={4} key={option.name}>
                    <Card
                      className={`transport-option-card h-100 text-center p-2 ${
                        tempSelection?.name === option.name
                          ? "selected"
                          : ""
                      } ${option.isOther ? "other-card" : ""}`}
                      onClick={() => handleSelect(option)}
                    >
                      {option.popular && (
                        <Badge className="popular-badge continue-btn-main">{t("transportModal.popular")}</Badge>
                      )}
                      <div className="card-img-wrapper">
                        <Card.Img
                          variant="top"
                          src={option.img}
                          alt={option.label}
                          className="transport-option-img"
                        />
                      </div>
                      
                      <Card.Body className="p-2">
                        <Card.Title className="transport-option-label">{t(option.label)}</Card.Title>
                        <span className="hero-subtitle">{t(option.des)}</span>
                        {option.isOther && (
                          <small className="text-muted">{t("transportModal.otherDescription")}</small>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
                {/* Add "Weiter" button in the first category row */}
                {/* {catIndex === 0 && (
                  <Col xs={6} md={4} className="d-flex align-items-center justify-content-center">
                    <Button
                      className="continue-btn-inline"
                      onClick={() => setShowModal(false)}
                      disabled={!tempSelection}
                    >
                      {t("transportModal.continue")} →
                    </Button>
                  </Col>
                )} */}
              </Row>
            </div>
          ))}
        </Modal.Body>
      </Modal>

    </>
  );
}
